import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { AdjustmentTable } from "./AdjustmentTable";
import { AdjustmentForm } from "./AdjustmentForm";

const thisMonth = () => new Date().toISOString().slice(0, 7);
const emptyForm = { user_id: "", type: "reimbursement", label: "", amount: "" };

export const AdjustmentsPanel = () => {
  const [month, setMonth] = useState(thisMonth());
  const [list, setList] = useState([]);
  const [emps, setEmps] = useState([]);
  const [form, setForm] = useState(emptyForm);

  const load = useCallback(() => api.get("/payroll/adjustments", { params: { month } }).then((r) => setList(r.data)), [month]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { api.get("/employees").then((r) => setEmps(r.data.filter((e) => e.status === "active"))); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/payroll/adjustments", { ...form, month, amount: +form.amount });
      toast.success("Adjustment added — it will apply when payroll is run");
      setForm(emptyForm);
      load();
    } catch (err) { toast.error(errText(err)); }
  };

  const del = async (id) => {
    try {
      await api.delete(`/payroll/adjustments/${id}`);
      toast.success("Adjustment removed");
      load();
    } catch (err) { toast.error(errText(err)); }
  };

  return (
    <div className="space-y-6" data-testid="adjustments-panel">
      <div className="bg-white border border-stone-200 rounded-lg p-6 space-y-4">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h3 className="font-heading font-bold">Reimbursements & one-off deductions</h3>
          <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="adjustment-month-input"
            className="min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white" />
        </div>
        <p className="text-xs text-stone-500">Added items flow into the payslip when payroll is run for that month. Locked once payroll is processed.</p>
        <AdjustmentForm emps={emps} form={form} setForm={setForm} onSubmit={add} />
      </div>

      <AdjustmentTable list={list} month={month} onDelete={del} />
    </div>
  );
};
